// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2Rx1R","wrapper":"_1zRzU","leftSection":"_2q5kX","heading":"_2kAEw","subHeading":"_3QHsc","sourceData":"_2zNU9","rightSection":"_1zgaf"};